export default __webpack_public_path__ + "static/paper_bg-ce33f3f2039bf8a0513c3d0f9d2cbc14.png";